import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { getFiltrarCupones, getLocalesFiltrarPorNombre } from "../../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FitrosCanjesComponents from "../../../../components/FitrosCanjesComponents";



function CanjesPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);

    const [locales, setLocales] = useState([]);
    const [localesSearch, setLocalesSearch] = useState('');
    const [localesSelected, setLocalesSelected] = useState(null);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);

    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [usuarioNameSearch, setUsuarioNameSearch] = useState('');
    const [nameSelected, setNameSelected] = useState(null);
    const [loadingCargarName, setLoadingCargarName] = useState(false);

    const [dataCompraManual, setDataCompraManual] = useState([]);
    const [compraManualSearch, setCompraManualSearch] = useState('');
    const [compraManualSelected, setCompraManualSelected] = useState({ label: 'Todos', value: "todos", id: 3 });


    const [dataCupones, setDataCupones] = useState([]);

    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaFinBackend, setFechaFinBackend] = useState('');




    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();


    useEffect(() => {
        if (stateToken) {
            setLoading(true);
        }
    }, [stateToken]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (localesSearch.length > 2) {
                setLoadingCargarLocales(true);
                handleListarLocales(localesSearch);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, localesSearch]);


    //=================================================================================================funcion para listar las categorias
    const handleListarLocales = (busqueda) => {

        getLocalesFiltrarPorNombre(busqueda, stateToken?.access_token)
            .then((response) => {
                console.log("response-getLocalesFiltrarPorNombre", response?.data);
                setLoadingCargarLocales(false);
                if (response.data.length > 0) {
                    setLocales(response.data);
                } else {
                    setLocales([]);
                }
            })
            .catch((error) => {
                console.log("error-getLocalesFiltrarPorNombre", error);
                setLoadingCargarLocales(false);
                setLocales([]);
            });
    };

    //=============================================funcion para listar los cupones por fecha desde procesamiento
    const handleFiltrarFechaInicioProcesamientoApi = (fechaInicioBusqueda) => {
        setLoadingCargar(true);

        getFiltrarCupones(
            fechaInicioBusqueda,
            fechaFinBackend === "" ? "" : fechaFinBackend,
            nameSelected?.id === undefined ? "" : nameSelected?.id,
            compraManualSelected?.key === undefined ? "" : compraManualSelected?.key,
            stateToken?.access_token
        ).then((response) => {
            // console.log("response-getUsuarios", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataCupones(response.data);

                setLoading(true);
            } else {
                setDataCupones([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getUgetFiltrarCuponessuarios", error);
                setLoadingCargar(false);

                setDataCupones([]);
                setLoading(true);
            });
    };

    //=============================================funcion para listar los cupones por fecha hasta procesamiento
    const handleFiltrarFechaHastaProcesamientoApi = (fechaHastaBusqueda) => {
        setLoadingCargar(true);

        getFiltrarCupones(
            fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fechaHastaBusqueda,
            nameSelected?.id === undefined ? "" : nameSelected?.id,
            compraManualSelected?.key === undefined ? "" : compraManualSelected?.key,
        ).then((response) => {
            // console.log("response-getUsuarios", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataCupones(response.data);

                setLoading(true);
            } else {
                setDataCupones([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getUgetFiltrarCuponessuarios", error);
                setLoadingCargar(false);

                setDataCupones([]);
                setLoading(true);
            });
    };





    //=============================================funcion para listar los cupones por nombre del usuario
    const handleFiltrarNameUsuarioApi = (nameUsuarioBusqueda) => {
        setLoadingCargar(true);

        getFiltrarCupones(
            fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fechaFinBackend === "" ? "" : fechaFinBackend,
            nameUsuarioBusqueda,
            compraManualSelected?.key === undefined ? "" : compraManualSelected?.key,
        ).then((response) => {
            // console.log("response-getUsuarios", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataCupones(response.data);
                setLoading(true);
            } else {
                setDataCupones([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getUgetFiltrarCuponessuarios", error);
                setLoadingCargar(false);

                setDataCupones([]);
                setLoading(true);
            });
    };






    //=============================================funcion para listar los cupones por cupones anulados
    const handleFiltrarCuponesAnuladosApi = (cuponesAnuladosBusquda) => {
        setLoadingCargar(true);

        getFiltrarCupones(
            fechaInicioBackend === "" ? "" : fechaInicioBackend,
            fechaFinBackend === "" ? "" : fechaFinBackend,
            nameSelected?.id === undefined ? "" : nameSelected?.id,
            cuponesAnuladosBusquda,
        ).then((response) => {
            // console.log("response-getUsuarios", response?.data);
            setLoadingCargar(false);
            if (response.data.length > 0) {
                setDataCupones(response.data);
                setLoading(true);
            } else {
                setDataCupones([]);
                setLoading(true);
            }
        })
            .catch((error) => {
                console.log("error-getUgetFiltrarCuponessuarios", error);
                setLoadingCargar(false);

                setDataCupones([]);
                setLoading(true);
            });
    };














    //=============================================funcion para editar
    const handleEditClick = (id) => {
        console.log('Edit', id);
        history(`/app/admin/cupon-detalle/${id}`);
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => {
        console.log('Delete', id);
        setDataCupones(dataCupones.filter((row) => row.id !== id));
    }


    const columns = [
        {
            field: 'fecha_hora',
            headerName: 'Fecha/Hora',
            flex: 1,
            editable: true,
        },
        {
            field: 'cliente',
            headerName: 'Usuario',
            flex: 1,
            editable: true,
        },
        {
            field: 'ci',
            headerName: 'Cédula',
            flex: 1,
            editable: true,
        },
        {
            field: 'monto_canjeado',    
            headerName: 'Monto Canjeado',
            flex: 1,
            editable: true,
        },
        {
            field: 'local',
            headerName: 'Local',
            flex: 1,
            editable: true,
        },
        {
            field: 'promocion',
            headerName: 'Promoción',
            flex: 1,
            editable: true,
        },
        {
            field: 'reservado',
            headerName: 'Reservado',
            flex: 1,
            editable: true,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            flex: 1,
            cellClassName: 'actions',
            getActions: ({ id }) => {

                return [
                    <GridActionsCellItem
                        icon={<Edit />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            handleEditClick(id);
                        }}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Delete />}
                        label="Delete"
                        onClick={() => {
                            handleDeleteClick(id);
                        }}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);

        //llamar a la funcion para filtrar por fecha inicio
        setTimeout(() => {
            handleFiltrarFechaInicioProcesamientoApi(fecha);
        }, 1000);
    };

    //=============================================funcion para seleccionar la fecha fin
    const handleFechaFin = (event) => {
        console.log("event", event);
        setFechaFin(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        console.log("fecha", fecha);
        setFechaFinBackend(fecha);

        //llamar a la funcion para filtrar por fecha fin
        setTimeout(() => {
            handleFiltrarFechaHastaProcesamientoApi(fecha);
        }, 1000);
    };






    //=============================================funcion para buscar el nombre del usuario
    const handleUsuarioNameSearch = (e) => {
        console.log("event-handleNameSearch------>", e);
        setUsuarioNameSearch(e);

    };

    //=========================================================funcion para seleccionar el nombre del usuario
    const handleNameSelected = (value) => {
        console.log("value-handleNameSelected##########>>> ", value);
        setNameSelected(value);

        if (value?.id !== undefined) {
            setTimeout(() => {
                handleFiltrarNameUsuarioApi(value?.id);
            }, 1000);
        }
    };


    //=============================================funcion para buscar el estado del cupon
    const handleComprasManualSearch = (event) => {
        console.log("event", event);
        setCompraManualSearch(event);
    };

    //=========================================================funcion para seleccionar el estado del cupon
    const handleComprasManualSelected = (value) => {
        console.log("value-handleCuponesAnuladosSelected: ", value);
        setCompraManualSelected(value);

        if (value?.key !== undefined) {
            setTimeout(() => {
                handleFiltrarCuponesAnuladosApi(value?.key);
            }, 1000);
        }
    };





    //=========================================================funcion para seleccionar local
    const handleLocalSelected = (value) => {
        console.log("value-handleCategoriaSelected: ", value);
        setLocalesSelected(value);

        if (value?.id !== undefined) {
            setTimeout(() => {
                // handleFiltrarLocalSeleccionadApi(value?.id);
            }, 1000);
        }
    };

    //=========================================================funcion para buscar local
    const handleSearchLocal = (value) => {
        console.log("value-handleSearchCategoria: ", value);
        setLocalesSearch(value);
    };





    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>
                {loading ? (
                    <div>
                        <FitrosCanjesComponents
                            title={'Canjes'}

                            fechaInicio={fechaInicio}
                            handleFechaInicio={handleFechaInicio}

                            fechaFin={fechaFin}
                            handleFechaFin={handleFechaFin}

                            nameUsunameSelectedario={nameSelected}
                            dataUsuarios={dataUsuarios}
                            loadingCargarName={loadingCargarName}
                            handleUsuarioNameSearch={handleUsuarioNameSearch}
                            handleNameSelected={handleNameSelected}

                            compraManualSelected={compraManualSelected}
                            handleComprasManualSearch={handleComprasManualSearch}
                            handleComprasManualSelected={handleComprasManualSelected}

                            dataLocales={locales}
                            loadingCargarLocales={loadingCargarLocales}
                            localesSelected={localesSelected}
                            handleLocalSelected={handleLocalSelected}
                            handleSearchLocal={handleSearchLocal}
                        />

                        <div style={{
                            backgroundColor: PaletaColor.BLANCO,
                            borderRadius: Padding.P1,
                            padding: Padding.P3,
                        }}>
                            <Box sx={{ width: '100%' }}>
                                <DataGrid
                                    rows={dataCupones}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5, 10, 25]}
                                    // checkboxSelection
                                    disableRowSelectionOnClick
                                />
                            </Box>
                        </div>
                    </div>
                ) : (
                    <Container sx={{}} style={{}}>
                        <SkeletonLoading />
                    </Container>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default CanjesPage;